"use client"

import { PhilippinePeso } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PhilippinePesoIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PhilippinePesoIcon = component(Icon)({ as: PhilippinePeso })
